import { useEffect, useState } from 'react';
import { DRIVER_DOC_LABEL, DRIVER_DOC_TYPES, type FileRow } from 'shared';
import { api } from './api';
import { FileGrid, UploadButton } from './Files';
import Hint from './Hint';
import { useFeature } from './features';

/**
 * Документы перевозчика.
 *
 * Лежат в профиле, а не в каждом рейсе: права и СТС не меняются от заказа
 * к заказу, а заказчик всё равно спросит их до погрузки. Видит их только
 * тот, с кем уже был общий рейс.
 */
export default function DriverDocs() {
  const [items, setItems] = useState<FileRow[]>([]);
  const [loaded, setLoaded] = useState(false);
  const on = useFeature('driverDocs');

  useEffect(() => {
    api
      .myDocs()
      .then((r) => setItems(r.items))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  if (!on || !loaded) return null;

  return (
    <div className="card">
      <h3>
        Документы{' '}
        <Hint k="docs" />
      </h3>

      {DRIVER_DOC_TYPES.map((t) => {
        const mine = items.filter((f) => f.docType === t);
        return (
          <div key={t} style={{ marginBottom: 12 }}>
            <div className="doc-row">
              <span className="meta">
                {DRIVER_DOC_LABEL[t]}
                {mine.length > 0 ? ` · ${mine.length}` : ''}
              </span>
              <UploadButton
                kind="DRIVER_DOC"
                docType={t}
                label={mine.length ? 'Ещё' : 'Загрузить'}
                onDone={(row) => setItems((prev) => [row, ...prev])}
              />
            </div>
            <FileGrid
              items={mine}
              onDelete={(id) => setItems((prev) => prev.filter((f) => f.id !== id))}
            />
          </div>
        );
      })}
    </div>
  );
}
